<template>
    <svg :width="props.width" :height="props.height" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.53739 1.89747L3.02239 4.84497C1.57489 5.78997 1.57489 7.90497 3.02239 8.84997L7.53739 11.7975C8.34739 12.33 9.68239 12.33 10.4924 11.7975L14.9849 8.84997C16.4249 7.90497 16.4249 5.79747 14.9849 4.85247L10.4924 1.90497C9.68239 1.36497 8.34739 1.36497 7.53739 1.89747Z"
            :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M4.22259 9.81006L4.21509 13.3276C4.21509 14.2801 4.95009 15.3001 5.85009 15.6001L8.24259 16.3951C8.65509 16.5301 9.33759 16.5301 9.75759 16.3951L12.1501 15.6001C13.0501 15.3001 13.7851 14.2801 13.7851 13.3276V9.84756"
            :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M16.05 11.25V6.75" :stroke="props.color" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: 'rgb(var(--locumate-primary-color-dark))',
  },
  width: {
    type: Number,
    default: 18,
  },
  height: {
    type: Number,
    default: 18,
  },
});
</script>